import React, {useLayoutEffect, useRef} from 'react';
import moment from 'moment';
import DatePicker from "react-datepicker";

const UserActivityDropdown = (props) => {
  const [dates, setDates] = React.useState(null);
  const [defaultDate, setDefaultDate] = React.useState(null);
  const [parsed, setParsed] = React.useState(null);

  const elemRef = useRef();
  useLayoutEffect(() => {
    if (elemRef.current) {
      props.measureCallback(elemRef.current);
    }
  }, [])

  const mapAction = {
    'referralMade': 'Submitted referral',
    'referralPage': 'Opened referral page',
    'emrLaunch': 'Launched from Epic',
    'conditionChange': 'Changed conditions'
  }

  const mapColors = {
    'referralMade': '#339900',
    'referralPage': '#f37736',
    'emrLaunch': '#0392cf',
    'conditionChange': '#ee4035'
  }

  let timeDiff = {
    STANFORD: 2
  }

  let timeZone = props.location && props.location.state && timeDiff[props.location.state.auth.instance] ? timeDiff[props.location.state.auth.instance] : 0;

  let type = props.data._id ? 'provider' : 'session';

  const parseDates = (d) => {
    let unq = props.data.uniqueSessions;
    let parsed = unq.filter(a => a.date === d);
    setParsed(parsed)
  }

  if(type === 'provider' && !dates) {
    let datesKeys = props.data.sessionsDates.map(k => moment(k).toDate())
    setDefaultDate(datesKeys[datesKeys.length-1])
    setDates(datesKeys);
    parseDates(moment(datesKeys[datesKeys.length-1]).format('M/D/YY'))
  }

  const dateChange = (d) => {
    setDefaultDate(d)
    parseDates(d)
  };

  const ReferralInfo = (props) => {
    let name, mrn;
    let patientInfo = props.info && props.info.patientInfo ? props.info.patientInfo.split('|') : []
    if(patientInfo.length > 1) {
      name = patientInfo[1]
      mrn = patientInfo[0]
    } else name = patientInfo[0]
    return <div>
      {props.info && <div style={{fontSize: 12, marginTop: 5}}>
        {props.info.patientInfo && <div>
          {name && <p style={{margin: '3px 0px'}}><b>Patient Name</b>: {name}</p>}
          {mrn && <p style={{margin: '3px 0px'}}><b>Patient MRN</b>: {mrn}</p>}
        </div>}
        {props.info.trials.length > 0 && <div>
          <p style={{margin: '3px 0px'}}><b>Trials:</b></p>
          <ul style={{margin: '3px 0px'}}>{props.info.trials.map((t, i) => <li key={i}>{t}</li>)}</ul>
        </div>}
      </div>}
    </div>
  }

  const Session = (props) => <div key={props.index} style={styles.userActivityTable.session}>
    <p style={{position: 'absolute', left: '-14px', fontSize: 10}}>{props.realIndex ? props.index+1 : props.index}</p>
    {props.data && props.data.map((s, i) => <div key={i} style={{padding: '8px 0px', borderBottom: i !== props.data.length-1 ? '1px solid rgba(0, 0, 0, 0.2)' : 'none'}}>
        <b style={{color: mapColors[s.action]}}>{mapAction[s.action]}</b>
        {s.conditions && <p style={{margin: '3px 0px 0px 0px'}}>{Array.isArray(s.conditions) ? s.conditions.join(', ') : s.conditions}</p>}
        {s.name && <p style={{margin: '3px 0px'}}><b>User Name</b>: {s.name}</p>}
        {s.email && <p style={{margin: '3px 0px'}}><b>User Email</b>: {s.email}</p>}
        <ReferralInfo info={s.referralInfo} />
        <p style={{margin: '3px 0px 0px 0px'}}><b>Time:</b> {moment(s.time).subtract({hour: timeZone}).format('lll')}</p>
    </div>
    )}
  </div>

  return <div style={{...styles.container, minHeight: type === 'provider' ? 295 : 270}} ref={elemRef}>
    {dates && <DatePicker
      dateFormat='MM/dd/yy'
      closeOnScroll={true}
      autoComplete='off'
      showMonthDropdown
      showYearDropdown
      dropdownMode='select'
      includeDates={dates}
      name="calendar"
      selected={moment(defaultDate).toDate()}
      onChange={e => dateChange(moment(e).format('M/D/YY'))}
      />}
    <div style={styles.userActivityTable.container}>
      {parsed && parsed.map((p, k) => {
        let sessions = p.sessions;
        return <Session data={sessions} index={k} realIndex last={k > parsed.length}/>
      })}
      {type === 'session' && <Session data={props.data.sessions} index={1}  />}
    </div>
  </div>
}

const styles = {
  container: {
    background: 'rgb(234, 236, 240) none repeat scroll 0% 0%',
    padding: 10,
    fontSize: 13
  },
  userActivityTable: {
    container: {
      height: 230,
      overflowY: 'scroll',
      padding: 10,
      backgroundColor: 'white',
      marginTop: 10,
      border: '1px solid rgba(0, 0, 0, 0.2)'
    },
    session: {
      margin: '10px 10px 30px 10px',
      border: '1px solid rgba(0, 0, 0, 0.2)',
      padding: '0px 5px',
      borderRadius: 5,
      position: 'relative',
      background: 'rgb(247, 249, 253) none repeat scroll 0% 0%'
    },
  },
}

export default UserActivityDropdown;

